import { styled } from '@mui/system';
import { DataGrid as DataGridMUI } from '@mui/x-data-grid';
import CircularProgressMUI from '@mui/material/CircularProgress';
import { Button } from 'components/ui';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  position: relative;
`;

export const DragOverPlaceholder = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: black;
  z-index: 2;
  opacity: 0.5;
`;

export const DataGrid = styled(DataGridMUI)`
  margin-top: 10px;
  border-top: none;
  border-left: none;
  border-right: none;
  line-height: normal;
  margin-bottom: 8px;

  .MuiDataGrid-columnHeader {
    font-weight: 700;
    font-size: 12px;
  }

  .MuiDataGrid-cell {
    padding: 4px 12px;
    font-size: 13px;
    min-height: 44px !important;
  }
`;

export const StatusIcon = styled('div')`
  width: 26px;
  height: 26px;
  border: 1px solid ${theme.palette.secondary.main};
  color: ${theme.palette.secondary.main};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;

  &.success {
    color: ${theme.palette.success.main};
    border-color: ${theme.palette.success.main};
  }

  &.error {
    color: ${theme.palette.error.main};
    border-color: ${theme.palette.error.main};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PrimaryText = styled('span')`
  color: ${theme.palette.primary.main};
`;

export const CircularProgress = styled(CircularProgressMUI)`
  width: 20px !important;
  height: 20px !important;
`;

export const AddAttachmentButton = styled(Button)`
  .MuiButtonBase-root {
    > .label {
      font-size: 14px;

      svg {
        width: 20px;
      }
    }
  }
`;

export const Dropzone = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 26px 0;
  height: 200px;
  border: 3px dashed ${theme.palette.border.light};
  font-size: 12px;
  color: ${theme.palette.secondary.main};

  &.error {
    color: ${theme.palette.error.main};
    border-color: ${theme.palette.error.main};
  }

  button {
    border: none;
    background: white;
    font-family: ${theme.typography.fontFamily};
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 125%;
    color: ${theme.palette.text.dark};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    cursor: pointer;

    .icon {
      width: 56px;
      height: 56px;
      background: ${theme.palette.primary.main};
      color: ${theme.palette.secondary.main};
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 21px;
        height: 21px;
        margin-top: 4px;
      }
    }
  }
`;
